import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-flyerimages-main",
    templateUrl: "./flyerimages.main.component.html",
    standalone: false
})
export class FlyerImagesMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
